/**
 * Inline tooltip for CFR guidance and non-expert help.
 */

import React, { useState } from 'react';

export default function PrivacyTooltip({ text, cfr }) {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-flex align-middle ml-1">
      <button
        type="button"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        className="text-slate-400 hover:text-blue-500 focus:outline-none rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold border border-slate-300 hover:border-blue-400"
        aria-label="Help"
      >
        i
      </button>
      {show && (
        <span
          className="absolute left-0 top-full mt-1 z-50 w-80 max-w-[90vw] p-3 text-xs text-slate-100 bg-slate-800 text-white rounded-xl shadow-xl"
          role="tooltip"
        >
          {text}
          {cfr && <span className="block mt-1 font-medium text-blue-200">{cfr}</span>}
        </span>
      )}
    </span>
  );
}
